const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSockit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 429 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-69.7017,-65.742)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-53.8448,67.9541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.983,76.386L133.792,76.386C132.233,76.386 130.745,77.036 129.686,78.179C128.626,79.323 128.092,80.856 128.21,82.41C128.905,91.514 131.759,98.263 136.59,103.174C143.405,110.101 154.65,113.487 171.222,113.487C198.939,113.487 214.251,101.864 214.251,83.28C214.251,76.324 212.369,70.709 208.849,66.234C207.288,64.251 205.375,62.48 203.097,60.931L206.495,60.931C208.04,60.931 209.515,60.293 210.573,59.167C211.631,58.042 212.177,56.529 212.082,54.988C211.555,46.465 208.637,38.674 201.872,32.944C195.594,27.626 185.691,23.974 170.358,23.974C142.65,23.974 129.058,35.539 129.058,53.893C129.058,64.184 133.345,71.56 140.983,76.386ZM165.402,83.486C165.53,83.824 165.698,84.118 165.926,84.365C166.368,84.842 167.039,84.999 167.848,85.16C168.971,85.383 170.282,85.462 171.799,85.462C172.922,85.462 174.103,85.315 175.069,85.151C173.799,84.793 172.22,84.492 170.275,84.21L165.402,83.486ZM175.907,53.112C175.487,52.707 174.869,52.538 174.204,52.374C173.063,52.093 171.763,51.999 170.358,51.999C169.875,51.999 169.381,52.031 168.904,52.082C169.447,52.201 170.006,52.308 170.537,52.38L175.907,53.112Z",
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-102.853,72.7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.429,107.666C314.496,107.666 325.803,103.136 333.651,95.431C341.551,87.676 346.05,76.618 346.05,63.198C346.05,49.777 341.551,38.72 333.651,30.964C325.803,23.26 314.496,18.729 300.429,18.729C286.363,18.729 275.056,23.26 267.208,30.964C259.308,38.72 254.809,49.777 254.809,63.198C254.809,76.618 259.308,87.676 267.208,95.431C275.056,103.136 286.363,107.666 300.429,107.666ZM300.429,75.753C298.566,75.753 296.956,75.401 295.746,74.363C293.418,72.367 292.626,68.632 292.626,63.198C292.626,57.763 293.418,54.028 295.746,52.032C296.956,50.994 298.566,50.642 300.429,50.642C302.293,50.642 303.903,50.994 305.113,52.032C307.441,54.028 308.233,57.763 308.233,63.198C308.233,68.632 307.441,72.367 305.113,74.363C303.903,75.401 302.293,75.753 300.429,75.753Z",
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-169.673,65.1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.517,115.267C475.76,115.267 493.081,100.665 494.409,77.75C494.499,76.212 493.95,74.705 492.892,73.584C491.835,72.464 490.362,71.828 488.821,71.828L462.901,71.828C460.01,71.828 457.594,74.031 457.328,76.91C457.135,78.988 456.59,80.541 455.436,81.484C454.193,82.499 452.465,82.778 450.517,82.778C448.686,82.778 447.134,82.487 445.99,81.506C443.781,79.614 443.155,76.041 443.155,70.799C443.155,65.526 443.801,61.902 446.022,59.969C447.158,58.981 448.699,58.675 450.517,58.675C452.25,58.675 453.782,58.933 454.92,59.8C455.951,60.585 456.519,61.866 456.81,63.545C457.277,66.226 459.604,68.184 462.325,68.184L488.389,68.184C489.97,68.184 491.477,67.516 492.538,66.344C493.599,65.172 494.115,63.607 493.959,62.034C491.799,40.268 475.112,26.33 450.517,26.33C436.673,26.33 425.467,30.861 417.666,38.581C409.833,46.332 405.338,57.385 405.338,70.799C405.338,84.212 409.833,95.265 417.666,103.016C425.467,110.736 436.673,115.267 450.517,115.267Z",
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-53.8448,67.9541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.222,107.889C194.839,107.889 208.654,99.115 208.654,83.28C208.654,69.451 199.876,62.104 182.464,59.655L169.781,57.926C163.44,57.062 160.558,55.621 160.558,52.02C160.558,48.707 163.008,46.401 170.358,46.401C177.131,46.401 182.031,48.418 182.175,55.333L206.495,55.333C205.632,41.367 197.429,29.571 170.358,29.571C146.887,29.571 134.656,38.346 134.656,53.893C134.656,67.866 144.729,74.781 160.414,77.086L171.078,78.67C180.014,79.967 182.32,81.84 182.32,85.441C182.32,88.899 179.581,91.059 171.799,91.059C163.728,91.059 160.27,88.899 159.406,81.984L133.792,81.984C135.231,100.841 146.887,107.889 171.222,107.889Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-102.853,72.7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.429,102.069C325.199,102.069 340.452,86.674 340.452,63.198C340.452,39.721 325.199,24.327 300.429,24.327C275.66,24.327 260.406,39.721 260.406,63.198C260.406,86.674 275.66,102.069 300.429,102.069Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-169.673,65.1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.517,109.669C472.405,109.669 487.669,97.296 488.821,77.426L462.901,77.426C462.181,85.206 457.285,88.375 450.517,88.375C442.165,88.375 437.557,83.189 437.557,70.799C437.557,58.408 442.165,53.077 450.517,53.077C456.709,53.077 461.173,55.959 462.325,62.586L488.389,62.586C486.517,43.725 471.829,31.927 450.517,31.927C426.189,31.927 410.935,47.322 410.935,70.799C410.935,94.274 426.189,109.669 450.517,109.669Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-199.059,-25.8138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.092,200.649L607.188,200.649L577.956,155.732L605.748,126.363L576.084,126.363L551.172,154.293L551.172,98.139L525.414,98.139L525.414,200.649L551.172,200.649L551.172,182.942L560.1,173.44L577.092,200.649Z",
    style: {
      fill: "rgb(38,38,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-261.031,-3.07408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.812,96.118L696.707,96.118L696.707,75.4L671.812,75.4L671.812,96.118ZM670.948,177.91L697.426,177.91L697.426,103.624L670.948,103.624L670.948,177.91Z",
    style: {
      fill: "rgb(38,38,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-208.304,-107.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.744,226.228L699.744,207.526L685.776,207.526L685.776,185.062L659.298,185.062L659.298,207.526L648.786,207.526L648.786,226.228L659.298,226.228L659.298,259.077C659.298,275.627 667.501,282.532 688.512,282.532C692.256,282.532 696.144,282.245 699.744,281.813L699.744,262.534L694.272,262.534C688.944,262.534 685.776,262.102 685.776,255.907L685.776,226.228L699.744,226.228Z",
    style: {
      fill: "rgb(38,38,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35088,0,0,1.35088,-41.4872,61.9745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.064,39.732L190.016,47.209L190.016,62.165L177.064,69.643L164.112,62.165L164.112,47.209L177.064,39.732Z",
    style: {
      fill: "rgb(26,26,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.497076,0,0,0.497076,109.69,108.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.064,39.732L190.016,47.209L190.016,62.165L177.064,69.643L164.112,62.165L164.112,47.209L177.064,39.732Z",
    style: {
      fill: "rgb(102,102,102)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00705,0,0,0.991701,-3.51259,0.545594)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.702,
    y: 65.742,
    width: 425.5,
    height: 120.5,
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSockit);
export default __webpack_public_path__ + "static/media/sockit.ee1ce8ffc72cb8e180e5da4c94759a6c.svg";
export { ForwardRef as ReactComponent };